import React, { useState } from "react";

/**
 * Square app logo. If `app.logo` is set, renders the image; if missing OR if
 * the image fails to load, falls back to a coloured tile with the first letter
 * of the app name. Single source of truth for app avatar rendering across all
 * public pages (home cards, app detail hero, rankings rows, versus, etc.).
 *
 * Props:
 *   - app: { name, logo?, color? }
 *   - className: tailwind sizing for the OUTER tile (e.g. "w-12 h-12 rounded-lg")
 *   - textClassName: font sizing for the fallback letter (e.g. "text-lg")
 */
const AppLogo = ({ app, className = "w-12 h-12 rounded-lg", textClassName = "text-lg" }) => {
  const [broken, setBroken] = useState(false);
  const showImage = !!app.logo && !broken;
  return (
    <div
      className={`flex items-center justify-center shrink-0 text-white font-heading overflow-hidden ${showImage ? "bg-white" : ""} ${textClassName} ${className}`}
      style={showImage ? undefined : { backgroundColor: app.color || "#2563EB" }}
      data-testid={`app-logo-${app.slug || "x"}`}
    >
      {showImage ? (
        <img
          src={app.logo}
          alt={app.name}
          className="w-full h-full object-cover"
          loading="lazy"
          onError={() => setBroken(true)}
        />
      ) : (
        (app.name || "?").charAt(0)
      )}
    </div>
  );
};

export default AppLogo;
